import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面不存在 - 迷人的保姆在线观看',
    description: '你访问的页面不存在或已被移动，请返回首页或剧集分类继续浏览精彩内容。',
  });

  return (
    <div className="w-full px-4 md:px-8 lg:px-12 py-20 md:py-28">
      <div className="max-w-xl mx-auto text-center">
        <span className="mx-auto w-20 h-20 rounded-full bg-background-100 flex items-center justify-center text-foreground-300 mb-6">
          <i className="ri-file-unknow-line text-4xl"></i>
        </span>
        <p className="font-label text-6xl md:text-7xl font-bold text-primary-200">404</p>
        <h1 className="mt-4 text-xl md:text-2xl font-bold text-foreground-950">页面不存在</h1>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
          你访问的页面可能已被移动或链接有误：<span className="font-label text-foreground-500">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line text-lg"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            <i className="ri-list-check-2 text-lg"></i>
            浏览剧集分类
          </Link>
        </div>
      </div>
    </div>
  );
}